import { lazy, Suspense } from 'react';
import LoadingCom from '../../../components/LoadingCom';
import PageErrorBoundary from '../../../components/PageErrorBoundary';

// const PricingOffer = lazy(() => import('./Index'));
const PricingOffer = lazy(() => import('./Index'));

export default function SuspendedPricingOfferPage(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <PricingOffer {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
